// extracted by mini-css-extract-plugin
export var active = "dropdownSectionBusinessTypes-module--active--8273a";
export var badge = "dropdownSectionBusinessTypes-module--badge--1ef38";
export var defaultImg = "dropdownSectionBusinessTypes-module--defaultImg--33c07";
export var feature = "dropdownSectionBusinessTypes-module--feature--1c108";
export var features = "dropdownSectionBusinessTypes-module--features--24393";
export var icon = "dropdownSectionBusinessTypes-module--icon--47f47";
export var image = "dropdownSectionBusinessTypes-module--image--0cf63";
export var imgWrap = "dropdownSectionBusinessTypes-module--imgWrap--e2047";
export var label = "dropdownSectionBusinessTypes-module--label--08670";
export var promo = "dropdownSectionBusinessTypes-module--promo--9f306";
export var text = "dropdownSectionBusinessTypes-module--text--d2450";
export var title = "dropdownSectionBusinessTypes-module--title--62931";